module.exports = __webpack_public_path__ + "img/Portal_Logo.a0836e09.png";